import "../commonStyle.css";
import {
  CAvatar,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../customPagination";
import CIcon from "@coreui/icons-react";
import { cilOptions, cilPeople } from "@coreui/icons";
import DefaultPost from "../../assets/images/DefaultProfilePic.jpg";
import ProperSpinner from "../spinner/ProperSpinner";
import { UPDATE_FEEDBACK_LIST } from "../../store/actionTypes";
import { useNavigate } from "react-router-dom";
import { getDateAndTimeFormatted } from "../../utils/commonFunctions";
import ROUTE_NAMES from "../../routes/routeNames";
import { BsSortNumericDownAlt, BsSortNumericDown } from "react-icons/bs";
import { BsSortAlphaDown, BsSortAlphaDownAlt } from "react-icons/bs";
import { FiFilter } from "react-icons/fi";
import CustomModal from "../customModal";
import { FeedbackStatus } from "../../utils/contentTypes";

/**
 * @function FeedbackTable
 * @description for FeedbackTable
 * @returns JSX for FeedbackTable
 */

const FeedbackTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filterModal, setFilterModal] = useState(false);
  const {
    dataList: feedbackList,
    pageNo,
    totalPage,
    limit,
    isLoading,
    sortOrder,
    sortBy,
    status,
  } = useSelector((state) => state.FeedbackReducer);

  const [localStatus, setLocalStatus] = useState(status);

  const updatePage = (page) => {
    dispatch({
      type: UPDATE_FEEDBACK_LIST,
      payload: { pageNo: page },
    });
  };

  const pageLimitHandler = (e) => {
    const currLimit = e?.target?.value || 10;
    dispatch({
      type: UPDATE_FEEDBACK_LIST,
      payload: { limit: currLimit, pageNo: 1 },
    });
  };

  const handlerSort = (sortBy) => {
    dispatch({
      type: UPDATE_FEEDBACK_LIST,
      payload: { sortBy: sortBy, sortOrder: sortOrder === 1 ? -1 : 1 },
    });
  };

  const handleFilter = (newStatus) => {
    setFilterModal(false);
    dispatch({
      type: UPDATE_FEEDBACK_LIST,
      payload: { pageNo: 1, status: newStatus },
    });
  };

  const renderTableBody = () => {
    return (
      <CTableBody>
        {feedbackList?.length > 0 &&
          feedbackList.map((feedback, i) => {
            const serialNo = (pageNo - 1) * limit + (i + 1);
            const ProfilePic = feedback?.userData.profileImage || DefaultPost;
            const Feedback = feedback?.feedback || "N/A";
            const type = feedback?.type || "N/A";
            const userName =
              (feedback?.userData?.firstName || "") +
              " " +
              (feedback?.userData?.lastName || "");
            const displayName = userName.trim() || "N/A";
            const date = getDateAndTimeFormatted(feedback?.createdAt);
            const userId = feedback?.userData?._id || false;
            return (
              <CTableRow key={i} className="table-data-text">
                <CTableDataCell>{serialNo}</CTableDataCell>
                <CTableDataCell
                  onClick={() => {
                    navigate(`/feedback/${feedback?._id}`);
                  }}
                  className="name-link"
                >
                  {type}
                </CTableDataCell>
                <CTableDataCell title={Feedback}>
                  {Feedback?.length > 30
                    ? Feedback.substring(0, 30) + "..."
                    : Feedback}
                </CTableDataCell>
                <CTableDataCell className="table-heading-10-cell">
                  {feedback?.status === 4 ? (
                    <span className="badge rounded-pill bg-success">
                      Completed
                    </span>
                  ) : (
                    <span className="badge rounded-pill bg-danger">
                      Pending
                    </span>
                  )}
                </CTableDataCell>
                <CTableDataCell>
                  <span className="user--cell--style">
                    <CAvatar size="sm" src={ProfilePic} />
                    <span
                      className={`${userId && "name-link"}`}
                      onClick={() =>
                        navigate(ROUTE_NAMES.MAIN_ROUTES.USERS + `/${userId}`)
                      }
                    >
                      {displayName}
                    </span>
                  </span>
                </CTableDataCell>
                <CTableDataCell className=" text-center">{date}</CTableDataCell>
                {/* <CTableDataCell className="table-heading-10-cell">
                  <CIcon
                    size="sm"
                    icon={cilOptions}
                    className="name-link"
                    onClick={() => {
                      navigate(`/feedback/${feedback?._id}`);
                    }}
                  />
                </CTableDataCell> */}
              </CTableRow>
            );
          })}
      </CTableBody>
    );
  };

  const renderPagination = () => {
    return (
      <CustomPagination
        limit={+limit}
        limitHanlder={pageLimitHandler}
        pageNo={+pageNo}
        pageChangeHanlder={updatePage}
        totalPage={totalPage}
      />
    );
  };

  const renderNoDataFound = () => {
    if (isLoading) {
      return (
        <div className="ndf-container">
          <h3 className="ndf-heading">
            <span>{" Fetching feedbacks "}</span> {"..."}
          </h3>
        </div>
      );
    }
    return (
      <div className="ndf-container">
        <h3 className="ndf-heading">
          {"No"}
          <span>{" Feedback "}</span> {"available !!!"}
        </h3>
      </div>
    );
  };

  const renderModalBody = () => {
    return (
      <div className="filter-modal-body-container">
        <div className="info-sub-child-container">
          <label className="lable-text" htmlFor="diveType">
            {"Feedback Status"}
          </label>
          <select
            name="diveType"
            id="diveType"
            value={localStatus}
            onChange={(e) => {
              setLocalStatus(e.target.value);
            }}
            className="form-select form-select-md"
            aria-label="Select Dive Type"
          >
            <option value="">{"Show All"}</option>
            {Object.entries(FeedbackStatus).map(([key, value], index) => (
              <option key={index} value={value}>
                {key}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  const renderView = () => {
    return (
      <div>
        <CustomModal
          visible={filterModal}
          visibleHandler={() => {
            setFilterModal(false);
            setLocalStatus(status);
          }}
          heading={"Feedback Status"}
          body={renderModalBody}
          confirmHandler={() => handleFilter(localStatus)}
        />
        <div className="table-header-container">
          <h3 className="w-50 mb-0 text-primary">{"Feedback List"}</h3>
          <div
            className={`btn ${status ? "btn-primary" : "btn-outline-primary "} btn-sm add-btn add-btn-container `}
            onClick={() => setFilterModal(true)}
          >
            <span className="px-2">{"Filter"}</span>
            <span className="add-icon ">
              <FiFilter />
            </span>
          </div>
        </div>
        <CTable hover responsive>
          <CTableHead className="text-nowrap border">
            <CTableRow className="table-heading-text">
              <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                {"S. No."}
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell ${sortBy === "type" ? "sort-highlight" : ""}`}
              >
                {"Feedback Type"}
                <span onClick={() => handlerSort("type")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell ${sortBy === "feedback" ? "sort-highlight" : ""}`}
              >
                {"Description"}
                <span onClick={() => handlerSort("feedback")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                {"Status"}
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell ${sortBy === "userData.firstName" ? "sort-highlight" : ""}`}
              >
                <span className="user--cell--style">
                  <CIcon icon={cilPeople} />
                  {"User"}
                  <span onClick={() => handlerSort("userData.firstName")}>
                    {sortOrder === 1 ? (
                      <BsSortAlphaDown className="sort-icons cursor-pointer" />
                    ) : (
                      <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                    )}
                  </span>
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-20-cell text-center ${sortBy === "createdAt" ? "sort-highlight" : ""}`}
              >
                {"Created At"}
                <span onClick={() => handlerSort("createdAt")}>
                  {sortOrder === 1 ? (
                    <BsSortNumericDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortNumericDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          {isLoading ? <ProperSpinner /> : renderTableBody()}
        </CTable>
        {(feedbackList?.length >= 5 || pageNo > 1) && renderPagination()}
        {(isLoading || feedbackList?.length == 0) && renderNoDataFound()}
      </div>
    );
  };
  return <div>{renderView()}</div>;
};

export default FeedbackTable;
